import { selectOptionConvert } from '../../helpers/selectOptionConvert';
import { CashAllocationBase } from '../Base/CashAllocation';

export const TKACashAllocation = selectOptionConvert(CashAllocationBase);
